<template>
	<header class="relative">
		<div class="hero-head headroom header" :class="{'headroom--unpinned': scrolled , 'tiny-scroll' : scrolledTiny , 'header-scrolled' : largeScroll}"  v-on:scroll="handleScroll" >
			<slot></slot>
		</div>
	</header>
</template>

<script>
export default {
	name: 'sticky-header',
	data() {
		return {
			limitPosition: 500,
			scrolled: false,
			scrolledTiny:false,
			largeScroll : false,
			lastPosition: 0
		};
	},

	methods: {
		handleScroll() {
			if(window.scrollY > 0){
				this.scrolledTiny=true
			}
			else{
				this.scrolledTiny=false
			}
			if(window.scrollY > 100){
				this.largeScroll=true
			}
			else{
				this.largeScroll=false
			}
			if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY) {
				this.scrolled = true;
        // move up!
    } 

    if (this.lastPosition > window.scrollY) {
    	this.scrolled = false;
        // move down
    }

    this.lastPosition = window.scrollY;
      // this.scrolled = window.scrollY > 250;
  }
},
created() {
	window.addEventListener("scroll", this.handleScroll, {passive: true});
},
destroyed() {
	window.removeEventListener("scroll", this.handleScroll, {passive: true});
}
};
</script>
<style lang="scss">

</style>


// WEBPACK FOOTER //
// resources/assets/js/front/components/GeneralComponents/StickyHeader.vue